import PageBottomMenu from "./PageBottomMenu";

export default PageBottomMenu;
